import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 3584845F-971C-45BB-8184-CFEBE0044474
 * name skip-previous-circle
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/skip-previous-circle.svg
 * tags
 */
export const SkipPreviousCircleIcon = createSvgIcon(<><path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M8,8H10V16H8M16,8V16L11,12" /></>, 'SkipPreviousCircleIcon');
export default SkipPreviousCircleIcon